import cx from 'classnames';
import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {useSelector} from 'react-redux';
import {isIn3AcrossABTest} from '~/GalleryPB/experiments';
import {TemplateDesign, TemplateDetails} from '~/GalleryPB/Template/Template';
import {GalleryPromoTile} from './GalleryPromoTile';
import {buildHref, pickSrc} from './utils';

export const TemplateRow = ({
  results,
  screen,
  type,
  onTemplateClick,
  categoryId,
  favorites,
  templatesPerRowDesktop = 4,
  loading = 'eager',
  onClickQuickView,
}) => {
  const tracking = useSelector((state) => state.galleryData.tracking);
  const currentPage = useSelector((state) => state.galleryData.currentPage);

  const {premium} = results[0];
  const FREE_ROW_COUNT = screen === 'desktop' ? templatesPerRowDesktop : 2;
  const PREMIUM_ROW_COUNT = screen === 'desktop' ? templatesPerRowDesktop : 2;
  const offset = premium ? PREMIUM_ROW_COUNT : FREE_ROW_COUNT;
  const fabric = 'fabric ';

  const isCard = !!window.cards_page;

  const desktop = screen === 'desktop';
  if (offset < results.length) evite.error('Too many results in TemplateRow');
  const in3AcrossABTest = isIn3AcrossABTest();

  return (
    <div className={cx({'template-row__3-row-across-ABTest': in3AcrossABTest})}>
      <div
        className={`${fabric}gallery-template__row-${type}${isCard ? '' : '__invitation'}`}
        data-qa-id="gallery-templates__row"
      >
        {results.map((result, i) => {
          if (result.isPromoTile) {
            return (
              <GalleryPromoTile
                key={`promo-tile-${result.name?.replace(/\s+/g, '')}`}
                data={result}
                dataQaId="af-success-disc-amazon"
              />
            );
          }

          const src = pickSrc(result, desktop, true);
          const href = buildHref(result, tracking, currentPage);

          if (!result.assets || !src) {
            const missingString = [!result.assets && 'assets', !src && 'src']
              .filter(Boolean)
              .join(' and ');
            evite.error(
              `Template ${result.templateId} is missing ${missingString}, removing it from the row`
            );
            return null;
          }

          return (
            src && (
              <TemplateDesign
                key={result.templateId}
                result={{
                  ...result,
                  src,
                  categoryId,
                  position: i + 1,
                }}
                screen={screen}
                href={href}
                onTemplateClick={onTemplateClick}
                loading={loading}
                onClickQuickView={onClickQuickView}
                favorited={favorites.includes(result.templateId)}
              />
            )
          );
        })}
      </div>
      <div className={`${fabric}gallery-template__row-${type}${isCard ? '' : '__invitation'}`}>
        {results.map((result, i) => {
          const src = pickSrc(result, desktop, true);
          const href = buildHref(result, tracking, currentPage);
          return (
            src && (
              <TemplateDetails
                key={`td-${result.templateId}`}
                result={{
                  ...result,
                  categoryId,
                  position: i + 1,
                }}
                screen={screen}
                href={href}
                favorited={favorites.includes(result.templateId)}
                onTemplateClick={onTemplateClick}
              />
            )
          );
        })}
      </div>
    </div>
  );
};

TemplateRow.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
        PropTypes.number,
        PropTypes.bool,
      ])
    )
  ).isRequired,
  type: PropTypes.string.isRequired,
  favorites: PropTypes.arrayOf(PropTypes.string).isRequired,
  screen: PropTypes.oneOf(['mw', 'desktop']).isRequired,
  categoryId: PropTypes.string,
  onTemplateClick: PropTypes.func,
  templatesPerRowDesktop: PropTypes.number,
};
